import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateMemberIdOpenShift", function updateMemberIdOpenShift(memberId: string) {
    if (shiftEditorViewState().openShift) {
        shiftEditorViewState().openShift.memberId = memberId;
    }
});